export default "__VITE_ASSET__Dct68mG7__"